import React from "react";

import { Route, Switch, Redirect } from "react-router-dom";

import Login from "./Pages/Login/Login";

const LoggedOut = () => (
  <Switch>
    <Route exact path="/login" component={Login} />
    <Redirect to="/login" />
  </Switch>
);

export default LoggedOut;
